import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import API from "../api";
import { useNavigate } from "react-router-dom";

export default function MyLeads() {
  const [leads, setLeads] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    API.get("/leads/my").then(res => setLeads(res.data));
  }, []);

  const closeLead = async (id) => {
    await API.put(`/leads/${id}/close`);

    setLeads(leads.map(l =>
      l._id === id ? { ...l, status: "closed" } : l
    ));
  };

  return (
    <div className="flex">
      <Sidebar />

      <div className="flex-1 bg-gray-50 min-h-screen">
        <Navbar />

        <div className="p-6 space-y-6">

          <h1 className="text-2xl font-bold">My Leads</h1>

          {leads.length === 0 && (
            <div className="bg-white p-6 rounded shadow text-gray-500">
              No leads created yet
            </div>
          )}

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">

            {leads.map(l => (
              <div
                key={l._id}
                className="bg-white p-5 rounded-xl shadow"
              >
                {/* TITLE */}
                <h3 className="text-lg font-semibold">{l.title}</h3>

                <p className="text-sm text-gray-500">
                  {l.sector} · {l.stage}
                </p>

                {/* STATS */}
                <div className="mt-3 text-sm space-y-1 text-gray-600">
                  <p>CO₂: {l.co2Reduction || "N/A"}</p>
                  <p>Members: {l.members?.length || 0}</p>
                  <p>Messages: {l.messages?.length || 0}</p>
                </div>

                {/* STATUS */}
                <div className="mt-3">
                  <span className={`text-xs px-2 py-1 rounded ${
                    l.status === "open"
                      ? "bg-green-100 text-green-700"
                      : "bg-red-100 text-red-600"
                  }`}>
                    {l.status}
                  </span>
                </div>

                {/* ACTIONS */}
                <div className="mt-4 flex gap-2">

                  <button
                    onClick={() => navigate(`/lead/${l._id}`)}
                    className="flex-1 border rounded py-2 text-sm"
                  >
                    Manage
                  </button>

                  {l.status === "open" && (
                    <button
                      onClick={() => closeLead(l._id)}
                      className="flex-1 bg-red-500 text-white rounded py-2 text-sm"
                    >
                      Close
                    </button>
                  )}

                </div>
              </div>
            ))}

          </div>
        </div>
      </div>
    </div>
  );
}